export const validateRegistrationNumber = (
  regNumber: string,
  regexPatternsData?: string[]
): { valid: boolean; error?: string } => {
  if (!regNumber || regNumber.trim().length === 0) {
    return {
      valid: false,
      error: 'Please enter a registration number',
    }
  }

  if (!regexPatternsData || regexPatternsData.length === 0) {
    return {
      valid: false,
      error: 'Enter a valid registration number',
    }
  }

  const formattedRegNo = regNumber.toUpperCase().replace(/[. ,:-]+/g, '')
  const isValid = regexPatternsData.some(pattern => new RegExp(pattern, 'i').test(formattedRegNo))

  if (!isValid) {
    return {
      valid: false,
      error: 'Enter a valid registration number',
    }
  }

  return {
    valid: true,
  }
}

export const formatRegistrationNumber = (regNumber: string): string => regNumber.toUpperCase().trim()
